import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import SaleFormTest from './SaleFormTest'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { useSelector } from 'react-redux'
import { CheckBox, FormCustom, Input, Select, SwitchToggle, TextArea } from '../../Components/Form/Form';

const SaleTest = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [typePrint, setTypePrint] = useState(1)
    const [idPeriodCurrent, setIdPeriodCurrent] = useState(null);

    const [idDocumentPdf, setIdDocumentPdf] = useState('')
    const [modalShowPdf, setModalShowPdf] = useState(false);

    const [modalEvent, setModalEvent] = useState(false)
    const [modalEventPDF, setModalEventPDF] = useState('')

    const [regimen, setRegimen] = useState([]);
    const [cfdi, setCfdi] = useState([]);

    const jwt = useSelector(store => store.session.jwt)

    const [rowsBranchOffice, setRowsBranchOffice] = useState([])

    const [formatPayFac] = useState([
            { id: 'PUE', name: 'PUE' },
            { id: 'PPD', name: 'PPD' },
        ])

    const [timbrarID, setTimbrarID] = useState({
        p_id_document: '',
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen: '',
        p_id_cfdi: '',
        p_invoice_change: 0,
        p_invoice_change_data: {},
        p_full_name: '',
        p_payment_form_facturama: '',
    })
    const [modalShowTimbrar, setModalShowTimbrar] = useState(false);
    const [timbrarModal, setTimbrarModal] = useState({
        loadSubmit: false,
        hide: _ => setModalShowTimbrar(false),
    })
    const confirmTimbrar = _ => {
        if (parseInt(timbrarID.p_invoice_change) === 1) {
            if (!timbrarID.p_invoice_change_data?.rfc_customers || !timbrarID.p_invoice_change_data?.zip_code_invoice || !timbrarID.p_invoice_change_data?.full_name_invoice || !timbrarID.p_invoice_change_data?.id_regimen || !timbrarID.p_invoice_change_data?.id_cfdi || !timbrarID.p_invoice_change_data?.payment_form_facturama) {
                Helpers.toast.construct({ response: 'warning', message: 'Ingrese la información RFC, Código postal, Régimen Fiscal y Uso de CFDI y Forma de Pago', toast })
                return
            }
        } else {
            if (!timbrarID.p_rfc_customers || !timbrarID.p_zip_code_customers || !timbrarID.p_id_regimen || !timbrarID.p_id_cfdi || !timbrarID.p_payment_form_facturama) {
                Helpers.toast.construct({ response: 'warning', message: 'Ingrese la información RFC, Código postal, Régimen Fiscal y Uso de CFDI y Forma de Pago', toast })
                return
            }
        }

        setTimbrarModal({
            ...timbrarModal,
            loadSubmit: true
        })

        let dataFacturama = {}
        if (parseInt(timbrarID.p_invoice_change) === 1) {
            dataFacturama = {
                p_id_document: timbrarID.p_id_document,
                p_rfc_customers: timbrarID.p_invoice_change_data.rfc_customers,
                p_zip_code_customers: timbrarID.p_invoice_change_data.zip_code_invoice,
                p_id_regimen: timbrarID.p_invoice_change_data.id_regimen,
                p_id_cfdi: timbrarID.p_invoice_change_data.id_cfdi,
                p_payment_form_facturama: timbrarID.p_invoice_change_data.payment_form_facturama,
                p_full_name: timbrarID.p_invoice_change_data.full_name_invoice,
                p_invoice_change: timbrarID.p_invoice_change,
            }
        } else {
            dataFacturama = {
                p_id_document: timbrarID.p_id_document,
                p_rfc_customers: timbrarID.p_rfc_customers,
                p_zip_code_customers: timbrarID.p_zip_code_customers,
                p_id_regimen: timbrarID.p_id_regimen,
                p_id_cfdi: timbrarID.p_id_cfdi,
                p_payment_form_facturama: timbrarID.p_payment_form_facturama,
                p_invoice_change: timbrarID.p_invoice_change,
            }
        }

        Controllers.sale.send_to_facturama(dataFacturama).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShowTimbrar(false)
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setTimbrarModal({
                    ...timbrarModal,
                    loadSubmit: false
                })
                setReload(true)
            })
    }

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'ventas' })

    useEffect(() => {
        Controllers.regimen.get_regimen().then(res => {
            setRegimen(res.data)
        })
        Controllers.cfdi.get_cfdi().then(res => {
            setCfdi(res.data)
        })

        Controllers.worker.get_worker_branch_office_public().then(res => {
            setRowsBranchOffice(res.data)
        })
    }, [])

    const [dataFilter, setDataFilter] = useState({
        p_date_start: Helpers.date.get({ format: '%Y-%m-%d', addDays: -1 }),
        p_date_end: Helpers.date.get({ format: '%Y-%m-%d' }),
        p_id_branch_office: '',
    })

    useEffect(() => {
        if (reload) {
            const getData = _ => {
                setIsProccesing(true)

                Controllers.sale.get_sale({
                    ...dataFilter
                }).then(res => {
                    setRows(res.data.rows)
                    setIdPeriodCurrent(res.data.id_period)
                }).catch(req => Helpers.promise.catch({ req, toast }))
                    .finally(() => {
                        setIsProccesing(false)
                        setReload(false)
                    })
            }

            getData()
        }
    }, [reload, dataFilter])

    const branchOffice = useMemo(() => {
        if (!dataFilter.p_id_branch_office) {
            return
        }

        let finded = rowsBranchOffice.find(t => parseInt(dataFilter.p_id_branch_office) === parseInt(t.id_branch_office))

        if (!finded) {
            return
        }
        return {
            label: finded.key_branch_office + ' - ' + finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [dataFilter.p_id_branch_office, rowsBranchOffice])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.sale.test_sale_insert_update(data).then(res => {
            if (res.response === 'success') {
                if (res.data?.status_facturama === 'error') {
                    Helpers.toast.construct({ response: 'warning', message: res.message, toast })
                    setTypePrint(2)
                    setModalShow(false)
                    setDataUpdated({})
                    setIdDocumentPdf(res.data.id)
                    setModalShowPdf(true)
                } else {
                    Helpers.toast.construct({ ...res, toast })
                    if (res?.data?.id) {
                        setTypePrint(2)
                        setModalShow(false)
                        setDataUpdated({})
                        setIdDocumentPdf(res.data.id)
                        setModalShowPdf(true)
                    } else {
                        setModalShow(false)
                        setDataUpdated({})
                    }
                }
            } else {
                Helpers.toast.construct({ ...res, toast })
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idDocument) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idDocument, view = 0 } = $this.dataset

        Controllers.sale.get_sale_id({ p_id_sale: idDocument }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idDocument}`)
            setDataUpdated({ data: res.data, viewSubmit: parseInt(view) === 0 })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleDelete = () => {
        if (!dataDeleted.p_observation_anulado) {
            Helpers.toast.construct({ response: 'warning', message: 'Por favor, ingresar motivo', toast })
            return
        }
        setLoadSubmitDelete(true)

        Controllers.sale.sale_delete({
            ...dataDeleted,
        }).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idDocument } = e.currentTarget.dataset
        setDataDeleted({
            p_id_document: idDocument,
            p_observation_anulado: ''
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_document', text: 'ID', align: 'center' },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'name_branch_office', text: 'Nombre', align: 'center' },
                {
                    name: 'full_name_customers', text: 'Cliente', render: r => {
                        return r.id_customers + ' - ' + r.full_name_customers
                    }
                },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
                { name: 'total_doc', text: 'Total', align: 'center' },
                { name: 'code_period', text: 'Periodo', align: 'center' },
                {
                    name: 'source_doc', text: 'Tipo Venta', align: 'center', render: r => {
                        let text = 'VENTA'
                        let color = 'success'

                        switch (r.source_doc) {
                            case 'ECOMMERCE_PENDIENTE':
                                text = 'ECOMMERCE_PENDIENTE'
                                color = 'warning'
                                break;
                            case 'ECOMMERCE_PAGADO':
                                text = 'ECOMMERCE_PAGADO'
                                color = 'info'
                                break;

                            default:
                                break;
                        }

                        return <div className={'badge badge-' + (color)}>
                            {text}
                        </div>
                    }
                },
                {
                    name: 'has_invoice_doc', text: 'Factura', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.has_invoice_doc) === 1 ? 'success' : 'danger')}>
                            {parseInt(r.has_invoice_doc) === 1 ? 'Si' : 'No'}
                        </div>
                    }
                },
                {
                    name: 'facturama_id', text: 'Timbrado', align: 'center', render: r => {
                        if (parseInt(r.has_invoice_doc) === 0) {
                            return ''
                        }

                        if (parseInt(r.id_type_money) !== 2) {
                            return ''
                        }

                        return <div className='d-flex justify-content-center align-items-center'>
                            {parseInt(r.has_invoice_doc) === 1 && parseInt(r.anulado) === 0 && r.facturama_id && <div className='d-flex'>
                                <div className='badge badge-success align-self-center mr-2'>Timbrado</div>
                                <div className="align-self-center">
                                    <a href={Helpers.config.apiUrl({
                                        url: '/facturama/venta/pdf/' + r.facturama_id
                                    })} target='_blank' rel='noreferrer'>
                                        <Button variant="danger" size='xs' className='align-self-center'>
                                            <i className='fa fa-file-pdf'></i>
                                        </Button>
                                    </a>
                                </div>
                            </div>}

                            {parseInt(r.has_invoice_doc) === 1 && parseInt(r.anulado) === 1 && r.facturama_id && <div className='badge badge-danger'>Anulado</div>}

                            {parseInt(r.has_invoice_doc) === 1 && r.facturama_status === 'PENDING' && <div className='badge badge-info'>En Proceso</div>}

                            {parseInt(r.anulado) === 0 && parseInt(r.has_invoice_doc) === 1 && r.facturama_status === 'ERROR' && <Button variant="dark" size="sm" className='ml-2 d-flex' alt="Timbrar" style={{
                                fontSize: 10
                            }} onClick={e => {
                                if (parseInt(r.ecommerce_publico) === 1) {
                                    setModalShowTimbrar(true)
                                    setTimbrarID({
                                        p_invoice_change: 0,
                                        p_invoice_change_data: {},
                                        p_full_name: '',
                                        p_id_document: r.id_document,
                                        p_rfc_customers: r.rfc_customers,
                                        p_id_regimen: r.id_regimen,
                                        p_zip_code_customers: r.zip_code_invoice,
                                        p_id_cfdi: r.id_cfdi,
                                    })
                                } else {
                                    let $this = e.currentTarget

                                    let buttonHTML = $this.innerHTML;
                                    $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

                                    Controllers.customers.get_customers_id({ p_id_customers: r.id_customers }).then(res => {
                                        setModalShowTimbrar(true)
                                        setTimbrarID({
                                            p_invoice_change: r.invoice_change,
                                            p_invoice_change_data: {
                                                full_name_invoice: r.full_name_invoice ? r.full_name_invoice : '',
                                                zip_code_invoice: r.zip_code_invoice ? r.zip_code_invoice : '',
                                                id_regimen: r.id_regimen ? r.id_regimen : '',
                                                id_cfdi: r.id_cfdi ? r.id_cfdi : '',
                                                rfc_customers: r.rfc_customers ? r.rfc_customers : '',
                                                payment_form_facturama: r.payment_form_facturama ? r.payment_form_facturama : ''
                                            },
                                            p_full_name: res.data.full_name_customers,
                                            p_id_document: r.id_document,
                                            p_rfc_customers: res.data.rfc_customers,
                                            p_id_regimen: res.data.id_regimen,
                                            p_zip_code_customers: res.data.zip_code_customers,
                                            p_id_cfdi: res.data.id_cfdi,
                                            p_payment_form_facturama: res.data.payment_form_facturama,
                                        })
                                    }).catch(req => {
                                        Helpers.promise.catch({ req, toast })
                                        setReload(true)
                                    })
                                        .finally(() => $this.innerHTML = buttonHTML)
                                }
                            }}>
                                <i className='fas fa-file-invoice mr-2 align-self-center'></i>
                                <span className='align-self-center'>Timbrar</span>
                            </Button>}
                        </div>
                    }
                },
                {
                    name: 'pick_up_branch_office', text: 'Recojo Sucursal', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.pick_up_branch_office) === 1 ? 'success' : 'danger')}>
                            {parseInt(r.pick_up_branch_office) === 1 ? 'Si' : 'No'}
                        </div>
                    }
                },
                {
                    name: 'id_dispatch', text: 'Despacho', align: 'center', render: r => {
                        return <div className={'badge badge-' + r.color_dispatch}>
                            {r.name_dispatch}
                        </div>
                    }
                },
                {
                    name: 'anulado', text: 'Estado', align: 'center', render: r => {
                        return <div className={'text-center font-weight-bold text-' + r.anulado_color}>
                            {r.anulado_text}
                        </div>
                    }
                },
                {
                    name: 'ecommerce_publico', text: 'Ecommerce Público', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.ecommerce_publico) === 1 ? 'success' : 'secondary')}>
                            {parseInt(r.ecommerce_publico) === 1 ? 'Si' : 'No'}
                        </div>
                    }
                },
                {
                    name: 'user_created', text: 'Usuario', align: 'center'
                },
                {
                    name: 'has_event', text: 'Evento', align: 'center', render: u => {
                        return <>
                            {parseInt(u.has_event) === 1 ? <div className="badge badge-primary">
                                <i className="fas fa-ticket-alt mr-2"></i>
                                <span>EN PROCESO</span>
                            </div> : ''}
                            {parseInt(u.has_event) === 2 ? <Button variant={"primary"} className="ml-1" size="xs" onClick={_ => {
                                setModalEventPDF(Helpers.config.resourcesUrl({
                                    url: u.event_pdf
                                }))
                                setModalEvent(true)
                            }}>
                                <i className="fas fa-ticket-alt"></i>
                            </Button> : ''}
                        </>
                    }
                },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {/* parseInt(u.anulado) === 0 && actionsModule?.update ? <Button variant={actionsModule?.update.color_action} className="mr-1" size="xs" data-id-document={u.id_document} onClick={handleGet}>
                                <i className={actionsModule.update.icon}></i>
                            </Button> : '' */}
                            {/* actionsModule?.view ? <Button variant={actionsModule?.view.color_action} className="mr-1" size="xs" data-view={1} data-id-document={u.id_document} onClick={handleGet}>
                                <i className={actionsModule.view.icon}></i>
                            </Button> : '' */}
                            {/* parseInt(u.anulado) !== 1 && actionsModule?.ban && parseInt(u.id_period) === parseInt(idPeriodCurrent) ? <Button variant={actionsModule?.ban.color_action} size="xs" data-id-document={u.id_document} onClick={handleShowModalDelete}>
                                <i className={actionsModule.ban.icon}></i>
                            </Button> : '' */}
                            {/* parseInt(u.anulado) !== 1 && actionsModule?.print ? <Button variant={actionsModule?.print.color_action} className="ml-1" size="xs" onClick={_ => {
                                setTypePrint(1)
                                setIdDocumentPdf(u.id_document)
                                setModalShowPdf(true)
                            }}>
                                <i className={actionsModule.print.icon}></i>
                            </Button> : '' */}
                            {/* parseInt(u.anulado) !== 1 && actionsModule?.print ? <Button variant={"primary"} className="ml-1" size="xs" onClick={_ => {
                                setTypePrint(2)
                                setIdDocumentPdf(u.id_document)
                                setModalShowPdf(true)
                            }}>
                                <i className={actionsModule.print.icon}></i>
                            </Button> : '' */}
                            {/* parseInt(u.anulado) !== 1 && actionsModule?.print ? <Button variant={"dark"} className="ml-1" size="xs" onClick={_ => {
                                setTypePrint(3)
                                setIdDocumentPdf(u.id_document)
                                setModalShowPdf(true)
                            }}>
                                <i className={actionsModule.print.icon}></i>
                            </Button> : '' */}
                            <Dropdown>
                                <Dropdown.Toggle variant="primary" id="dropdown-basic">
                                    Acciones
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {parseInt(u.anulado) === 0 && actionsModule?.update && <Dropdown.Item data-id-document={u.id_document} onClick={handleGet}>
                                        <i className={'mr-2 ' + actionsModule.update.icon + ' text-' + actionsModule.update.color_action}></i>
                                        <span>{actionsModule.update.name_action}</span>
                                    </Dropdown.Item>}
                                    {actionsModule?.view && <Dropdown.Item data-view={1} data-id-document={u.id_document} onClick={handleGet}>
                                        <i className={'mr-2 ' + actionsModule.view.icon + ' text-' + actionsModule.view.color_action}></i>
                                        <span>{actionsModule.view.name_action}</span>
                                    </Dropdown.Item>}
                                    {parseInt(u.anulado) !== 1 && actionsModule?.ban && parseInt(u.id_period) === parseInt(idPeriodCurrent) && <Dropdown.Item data-view={1} data-id-document={u.id_document} onClick={handleShowModalDelete}>
                                        <i className={'mr-2 ' + actionsModule.ban.icon + ' text-' + actionsModule.ban.color_action}></i>
                                        <span>{actionsModule.ban.name_action}</span>
                                    </Dropdown.Item>}
                                    {parseInt(u.anulado) !== 1 && actionsModule?.print && <Dropdown.Item data-view={1} data-id-document={u.id_document} onClick={() => {
                                        setTypePrint(1)
                                        setIdDocumentPdf(u.id_document)
                                        setModalShowPdf(true)
                                    }}>
                                        <i className={'mr-2 ' + actionsModule.print.icon + ' text-' + actionsModule.print.color_action}></i>
                                        <span>{actionsModule.print.name_action} Factura</span>
                                    </Dropdown.Item>}
                                    {parseInt(u.anulado) !== 1 && actionsModule?.print && <Dropdown.Item data-view={1} data-id-document={u.id_document} onClick={() => {
                                        setTypePrint(3)
                                        setIdDocumentPdf(u.id_document)
                                        setModalShowPdf(true)
                                    }}>
                                        <i className={'mr-2 ' + actionsModule.print.icon + ' text-dark'}></i>
                                        <span>{actionsModule.print.name_action} Ticket v1</span>
                                    </Dropdown.Item>}
                                    {parseInt(u.anulado) !== 1 && actionsModule?.print && <Dropdown.Item data-view={1} data-id-document={u.id_document} onClick={() => {
                                        setTypePrint(2)
                                        setIdDocumentPdf(u.id_document)
                                        setModalShowPdf(true)
                                    }}>
                                        <i className={'mr-2 ' + actionsModule.print.icon + ' text-primary'}></i>
                                        <span>{actionsModule.print.name_action} Ticket v2</span>
                                    </Dropdown.Item>}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
        columnOrder="0"
        orderDirection="desc"
    />, [rows, isProcessing])

    const cboRegimen = useMemo(() => {
        if (parseInt(timbrarID.p_invoice_change) === 1) {
            if (!timbrarID.p_invoice_change_data?.id_regimen) {
                return ''
            }

            let finded = regimen.find(t => parseInt(timbrarID.p_invoice_change_data?.id_regimen) === parseInt(t.id_regimen))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_regimen} - ${finded.name_regimen}`,
                value: finded.id_regimen
            }
        } else {
            if (!timbrarID.p_id_regimen) {
                return ''
            }

            let finded = regimen.find(t => parseInt(timbrarID.p_id_regimen) === parseInt(t.id_regimen))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_regimen} - ${finded.name_regimen}`,
                value: finded.id_regimen
            }
        }
    }, [timbrarID.p_id_regimen, regimen, timbrarID.p_invoice_change_data, timbrarID.p_invoice_change])

    const cboCfdi = useMemo(() => {
        if (parseInt(timbrarID.p_invoice_change) === 1) {
            if (!timbrarID.p_invoice_change_data?.id_cfdi) {
                return ''
            }

            let finded = cfdi.find(t => (timbrarID.p_invoice_change_data?.id_cfdi) === (t.id_cfdi))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
                value: finded.id_cfdi
            }
        } else {
            if (!timbrarID.p_id_cfdi) {
                return ''
            }

            let finded = cfdi.find(t => (timbrarID.p_id_cfdi) === (t.id_cfdi))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
                value: finded.id_cfdi
            }
        }
    }, [timbrarID.p_id_cfdi, cfdi, timbrarID.p_invoice_change_data, timbrarID.p_invoice_change])

    const cboFormatPayFac = useMemo(() => {
        if (parseInt(timbrarID.p_invoice_change) === 1) {
            if (!timbrarID.p_invoice_change_data?.payment_form_facturama) {
                return ''
            }

            let finded = formatPayFac.find(t => (timbrarID.p_invoice_change_data?.payment_form_facturama) === (t.id))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.name}`,
                value: finded.id
            }
        } else {
            if (!timbrarID.p_payment_form_facturama) {
                return ''
            }

            let finded = formatPayFac.find(t => (timbrarID.p_payment_form_facturama) === (t.id))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.name}`,
                value: finded.id
            }
        }
    }, [timbrarID.p_payment_form_facturama, formatPayFac, timbrarID.p_invoice_change_data, timbrarID.p_invoice_change])

    /* if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2023-12-01') {
        return ''
    } */

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                {actionsModule?.new ? <Button variant={actionsModule?.new.color_action} size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> {actionsModule?.new.name_action} {nameSingle}
                </Button> : ''}
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    if (!dataFilter.p_id_branch_office) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccione una sucursal',
                            toast
                        })
                        return false;
                    }

                    setReload(true)
                }}>
                    <Select
                        classNameParent="col-6 mb-2"
                        icon="far fa-building"
                        text="Sucursal"
                        options={rowsBranchOffice.map(t => {
                            return {
                                label: t.key_branch_office + ' - ' + t.name_branch_office,
                                value: t.id_branch_office
                            }
                        })}
                        value={branchOffice}
                        onChange={e => setDataFilter({ ...dataFilter, p_id_branch_office: e.value })}
                    />
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        value={dataFilter.p_date_start}
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                    />
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        value={dataFilter.p_date_end}
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SaleFormTest onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <Modal show={modalShowPdf} onHide={_ => setModalShowPdf(false)} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">Documento de la Venta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe title='PDF Venta' className="w-100" style={{
                    minHeight: 700,
                    height: '80vh'
                }} src={typePrint === 1 ? Helpers.config.apiUrl({ url: '/sale/generate/invoice/' + idDocumentPdf + '?jwt=' + jwt }) : (typePrint === 2 ? Helpers.config.apiUrl({ url: '/sale/generate/invoice/new/ticket/' + idDocumentPdf + '?jwt=' + jwt }) : Helpers.config.apiUrl({ url: '/sale/generate/invoice/ticket/' + idDocumentPdf + '?jwt=' + jwt }))}></iframe>
            </Modal.Body>
        </Modal>
        <Modal show={modalEvent} onHide={_ => setModalEvent(false)} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">Ticket de evento de la venta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalEventPDF && <iframe title='PDF Evento Ticket Venta' className="w-100" style={{
                    minHeight: 700,
                    height: '80vh'
                }} src={modalEventPDF}></iframe>}
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea anular {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_document}</>}
            confirmButtonText="¡Sí, anular!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
            content={_ => {
                return <>
                    <TextArea
                        classNameParent="col-12"
                        icon="far fa-comment-alt"
                        placeholder="Motivo"
                        text="Motivo"
                        id="observation_anulado"
                        required
                        rows={4}
                        value={dataDeleted.p_observation_anulado}
                        onChange={e => setDataDeleted({ ...dataDeleted, p_observation_anulado: e.currentTarget.value })}
                    />
                </>
            }}
        />
        <SweetAlert
            icon="approve"
            iconClassName="fas fa-file-invoice text-primary"
            show={modalShowTimbrar}
            showCancelButton
            title={<>¿Desea timbrar la venta?</>}
            subtitle={<>#{timbrarID.p_id_document}</>}
            confirmButtonText="¡Sí, timbrar!"
            cancelButtonText="¡No, cancelar!"
            loadSubmit={timbrarModal.loadSubmit}
            onCancel={timbrarModal.hide}
            onConfirm={confirmTimbrar}
            content={_ => {
                return <>
                    <CheckBox
                        id="switch-my-invoice"
                        classNameParent="col-12 mt-2 align-self-center"
                        text="Factura a otro nombre"
                        checked={parseInt(timbrarID.p_invoice_change) === 1}
                        onChange={e => {
                            setTimbrarID({ ...timbrarID, p_invoice_change: e.currentTarget.checked ? 1 : 0 })
                        }}
                    />
                    <Input
                        text="Nombre Factura"
                        placeholder="Nombre Factura"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarID.p_invoice_change) === 1 ? timbrarID.p_invoice_change_data?.full_name_invoice : timbrarID.p_full_name}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, full_name_invoice: e.currentTarget.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_full_name: e.currentTarget.value
                                })
                            }
                        }}
                        disabled={parseInt(timbrarID.p_invoice_change) === 0}
                    />
                    <Input
                        text="RFC"
                        placeholder="RFC"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarID.p_invoice_change) === 1 ? timbrarID.p_invoice_change_data?.rfc_customers : timbrarID.p_rfc_customers}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, rfc_customers: e.currentTarget.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_rfc_customers: e.currentTarget.value
                                })
                            }
                        }}
                    />
                    <Input
                        text="Código Postal"
                        placeholder="Código Postal"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarID.p_invoice_change) === 1 ? timbrarID.p_invoice_change_data?.zip_code_invoice : timbrarID.p_zip_code_customers}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, zip_code_invoice: e.currentTarget.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_zip_code_customers: e.currentTarget.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Uso de CFDI"
                        options={cfdi.map(t => {
                            return {
                                label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                value: t.id_cfdi
                            }
                        })}
                        value={cboCfdi}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, id_cfdi: e.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_id_cfdi: e.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Régimen Fiscal"
                        options={regimen.filter(r => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                if (!timbrarID.p_invoice_change_data?.id_cfdi) {
                                    return false
                                }
                            } else {
                                if (!timbrarID.p_id_cfdi) {
                                    return false
                                }
                            }

                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarID.p_invoice_change_data?.id_cfdi)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            } else {
                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarID.p_id_cfdi)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            }
                        }).map(t => {
                            return {
                                label: `${t.id_regimen} - ${t.name_regimen}`,
                                value: t.id_regimen
                            }
                        })}
                        value={cboRegimen}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, id_regimen: e.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_id_regimen: e.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Forma de Pago"
                        options={formatPayFac.map(t => {
                            return {
                                label: `${t.name}`,
                                value: t.id
                            }
                        })}
                        value={cboFormatPayFac}
                        onChange={e => {
                            if (parseInt(timbrarID.p_invoice_change) === 1) {
                                setTimbrarID({ ...timbrarID, p_invoice_change_data: { ...timbrarID.p_invoice_change_data, payment_form_facturama: e.value } })
                            } else {
                                setTimbrarID({
                                    ...timbrarID,
                                    p_payment_form_facturama: e.value
                                })
                            }
                        }}
                    />
                </>
            }}
        />
    </>
}

export default SaleTest